import React from "react";
import MobileLayout from "../../Shared/MobileLayout";
import MobileNotice from "../../Shared/MobileNotice";
import OriginalComponentImpl from "../../../Components/AIML/ShowQuantAnalysis";

const OriginalComponent = OriginalComponentImpl as unknown as React.ComponentType<any>;

interface Props {
  [key: string]: any;
}

const ShowQuantAnalysisMobile: React.FC<Props> = (props) => {
  return (
    <MobileLayout title="ShowQuantAnalysis">
      <MobileNotice page="ShowQuantAnalysis" />
      <OriginalComponent {...props} />
    </MobileLayout>
  );
};

export default ShowQuantAnalysisMobile;